import { useContext } from "react";
import Slider from "../common/Slider";
import { getSliderSettings } from "./recentJobGroup";
import CareerCard from "../cards/careerInfo";
import { JobOpeningContext } from "../../App";

import { Briefcase } from "lucide-react";

const CareerGroup = () => {
    const jobOpenings = useContext(JobOpeningContext);

    const settings = getSliderSettings({
        dots: true,
        arrows: true,
        slidesToShow: 3,
        removeAutoPlay: false,
        slidesToShowAt1024Breakpoint: 2,
        slidesToShowAt992Breakpoint: 1,
        objectCount: Object.keys(jobOpenings).length,
        speed: 500,
        autoplaySpeed: 15000,
    });
    return (
        <section className="cht-py-16 cht-bg-white !cht-font-body">
            {Object.keys(jobOpenings).length === 0 ? (
                <div className="cht-max-w-xl cht-mx-auto cht-text-center cht-px-4 cht-py-12 cht-bg-slate-50 cht-rounded-[24px] cht-border cht-border-slate-200/80">
                    <h2 className="cht-text-2xl sm:cht-text-3xl cht-font-bold !cht-font-heading cht-text-[#1e293b]">
                        We Are Currently Not Actively Recruiting
                    </h2>
                    <p className="cht-text-sm sm:cht-text-base cht-text-slate-600 cht-mt-2">
                        Stay tuned for upcoming career opportunities and talent searches!
                    </p>
                </div>
            ) : (
                <div className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8">
                    <header className="cht-text-center cht-mb-10">
                        <span className="cht-inline-flex cht-items-center cht-gap-1.5 cht-px-3.5 cht-py-1.5 cht-rounded-full cht-text-xs cht-font-semibold cht-bg-[#3e57da]/10 cht-text-[#3e57da] cht-mb-3 cht-tracking-wide cht-uppercase">
                            <Briefcase className="cht-w-3.5 cht-h-3.5" />
                            Open Roles
                        </span>
                        <h2 className="cht-text-3xl sm:cht-text-4xl cht-font-bold !cht-font-heading cht-text-[#1e293b] cht-tracking-tight">
                            Available Positions
                        </h2>
                        <p className="cht-text-sm sm:cht-text-base cht-text-slate-600 cht-mt-2.5">
                            Discover our current career openings and opportunities below
                        </p>
                    </header>

                    <Slider {...settings}>
                        {jobOpenings.map((item) => (
                            <div key={item.id} className="cht-p-3">
                                <CareerCard
                                    title={item.job_title}
                                    deadline={item.deadline}
                                    experience={item.years_of_experience}
                                    skills={item.skills}
                                    slug={item.slug}
                                    id={item.id}
                                    qualification={item.qualification}
                                />
                            </div>
                        ))}
                    </Slider>
                </div>
            )}
        </section>
    );
};

export default CareerGroup;
